<template>
    <div>
      <slot :props="{ 'error-messages': getError()}"></slot>
    </div>
</template>

<script>
import { getMessages } from '@/validations';

export default {
  name: 'Validate',
  props: {
    v: {
      type: Object,
      default() {
        return {
          $invalid: false,
          $dirty: false,
          $params: [],
        };
      },
    },
  },
  methods: {
    getError() {
      if (!this.v.$dirty) { return ''; }

      for (const p in this.v.$params) {
        if (!this.v[p]) {
          return getMessages(p, this.v.$params[p]);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.input-block{
  width: 60%;
  position: relative;
  margin-bottom: 13px;

  .radio-block {
    display: flex;
    flex-wrap: wrap;
  }

  .lb{
    display: block;
    font-weight: 600!important;
  }
  .helper-text{
    font-size: 11px;
    margin-top: 1px;
    margin-left: 12px;
  }
  .validator-error{
    color: #b00020;

  }
}

.input-block-margin{
  border: 1px solid #757575;
  padding: 13px 9px 5px 9px;
  border-radius: 4px;
  margin-top: 6px;

  .lb{
    transform: translateX(-4%) translateY(-113%) scale(.90);
    background-color: white;
    position: absolute;
    padding: 0px 4px;
  }
}

@media only screen and (max-width: 700px){
  .input-block{
    width: 100%;
  }
}
</style>
